import { render, staticRenderFns } from "./SelectionClauseEditor.vue?vue&type=template&id=559a7a39&scoped=true"
import script from "./SelectionClauseEditor.vue?vue&type=script&lang=ts"
export * from "./SelectionClauseEditor.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SelectionClauseEditor.vue?vue&type=style&index=1&id=559a7a39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a7a39",
  null
  
)

export default component.exports